import { useServiceError } from '@/hooks';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  createNfsInstallment,
  deleteNfsInstallment,
  nfsEditInstallment,
  nfsInstallments,
  updateNfsInstallment,
} from './Installment.service';
import { notification } from 'antd';
import {
  CreateNfsInstallment,
  InstallmentEditRequest,
  UpdateNfsInstallment,
} from './Installment.types';

export function useNfsInstallments(id: number) {
  const query = useQuery(['List-NfsInstallments'], () => nfsInstallments(id));

  useServiceError(query.error);

  return query;
}

export function useNfsInstallment() {
  const mutation = useMutation(nfsEditInstallment);

  useServiceError(mutation.error);

  return mutation;
}

export function useCreateNfsInstallment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: CreateNfsInstallment) => createNfsInstallment(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcela da nota fiscal de serviço criada com êxito!',
        });

        queryClient.invalidateQueries(['List-NfsInstallments']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateNfsInstallment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: UpdateNfsInstallment) => updateNfsInstallment(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcela da nota fiscal de serviço editada com êxito!',
        });

        queryClient.invalidateQueries(['List-NfsInstallments']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteNfsInstallment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: InstallmentEditRequest) => deleteNfsInstallment(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcela excluida com sucesso',
        });

        queryClient.invalidateQueries(['List-NfsInstallments']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
